<template>
  <div class="page">
    <div class="container">
      <h1>Mobile Apps</h1>
      <div class="service-content">
        <div class="service-intro">
          <p>Native and cross-platform mobile applications that engage users on any device.</p>
        </div>
        <div class="features">
          <div class="feature">
            <h3>iOS Development</h3>
            <p>Native Swift applications for iPhone and iPad</p>
          </div>
          <div class="feature">
            <h3>Android Development</h3>
            <p>Kotlin and Java apps for Android devices</p>
          </div>
          <div class="feature">
            <h3>Cross-Platform</h3>
            <p>React Native and Flutter for multi-platform deployment</p>
          </div>
          <div class="feature">
            <h3>App Store Optimization</h3>
            <p>Publishing and optimization for maximum visibility</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.page {
  padding: 2rem;
  height: 100%;
  background: #f5f5f5;
  color: #333;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

h1 {
  font-size: 3rem;
  margin-bottom: 2rem;
  text-align: center;
}

.service-intro {
  text-align: center;
  margin-bottom: 3rem;
}

.service-intro p {
  font-size: 1.3rem;
  max-width: 600px;
  margin: 0 auto;
}

.features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
}

.feature {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  text-align: center;
}

.feature h3 {
  margin-bottom: 1rem;
  font-size: 1.5rem;
  color: #2c3e50;
}

.feature p {
  font-size: 1.1rem;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .page {
    padding: 1rem;
  }
  
  h1 {
    font-size: 2rem;
  }
  
  .features {
    grid-template-columns: 1fr;
  }
}
</style>